{
  "{{ commaSeparatedUsers }} and {{ moreCount }} more": "{{ commaSeparatedUsers }} 그리고 {{ moreCount }}명 더",
  "{{ commaSeparatedUsers }}, and {{ lastUser }}": "{{ commaSeparatedUsers }} 그리고 {{ lastUser }}",
  "{{ count }} files_one": "{{ count }}개 파일",
  "{{ count }} files_other": "{{ count }}개 파일",
  "{{ count }} members_other": "{{ count }}명 멤버",
  "{{ count }} members added_other": "{{ count }}명 멤버가 추가됨",
  "{{ count }} people are typing_one": "{{ count }}명이 입력 중입니다",
  "{{ count }} people are typing_many": "{{ count }}명이 입력 중입니다",
  "{{ count }} people are typing_other": "{{ count }}명이 입력 중입니다",
  "{{ count }} photos_one": "{{ count }}개 사진",
  "{{ count }} photos_other": "{{ count }}개 사진",
  "{{ count }} reactions_other": "{{ count }}개 반응",
  "{{ count }} videos_one": "{{ count }}개 동영상",
  "{{ count }} videos_other": "{{ count }}개 동영상",
  "{{ firstUser }} and {{ secondUser }}": "{{ firstUser }} 그리고 {{ secondUser }}",
  "{{ imageCount }} more": "{{ imageCount }}개 더",
  "{{ member }} will be able to message you again.": "{{ member }}님이 다시 메시지를 보낼 수 있습니다.",
  "{{ member }} won't be able to message you anymore.": "{{ member }}님은 더 이상 메시지를 보낼 수 없습니다.",
  "{{ memberCount }} members": "{{ memberCount }}명",
  "{{ typing }} are typing": "{{ typing }} 입력 중입니다",
  "{{ typing }} is typing": "{{ typing }} 입력 중입니다",
  "{{ user }} has been muted": "{{ user }} 음소거되었습니다",
  "{{ user }} has been unmuted": "{{ user }} 음소거가 해제되었습니다",
  "{{ user }} is typing...": "{{ user }}이(가) 입력 중입니다...",
  "{{ users }} and {{ user }} are typing...": "{{ users }}와(과) {{ user }}이(가) 입력 중입니다...",
  "{{ users }} and more are typing...": "{{ users }}와(과) 더 많은 사람들이 입력 중입니다...",
  "{{ watcherCount }} online": "{{ watcherCount }} 온라인",
  "{{count}} new messages_one": "{{count}}개의 새 메시지",
  "{{count}} new messages_other": "{{count}}개의 새 메시지",
  "{{count}} unread_one": "{{count}} 읽지 않음",
  "{{count}} unread_other": "{{count}} 읽지 않음",
  "{{count}} votes_one": "{{count}} 투표",
  "{{count}} votes_other": "{{count}} 투표",
  "+{{ imageCount }}": "+{{ imageCount }}",
  "+{{count}} more options_one": "옵션 {{count}}개 더",
  "+{{count}} more options_other": "옵션 {{count}}개 더",
  "🏙 Attachment...": "🏙 부착...",
  "📊 {{createdBy}} created: {{ pollName}}": "📊 {{createdBy}}이(가) 생성함: {{ pollName}}",
  "📊 {{votedBy}} voted: {{pollOptionText}}": "📊 {{votedBy}}이(가) 투표함: {{pollOptionText}}",
  "📍Shared location": "📍공유된 위치",
  "Actions": "Actions",
  "Add": "추가",
  "Add {{ count }} members_other": "{{ count }}명 멤버 추가",
  "Add a comment": "댓글 추가",
  "Add a comment to your poll answer": "투표 답변에 댓글 추가",
  "Add an option": "옵션 추가",
  "Add channel members": "채널 멤버 추가",
  "Add members": "멤버 추가",
  "Add reaction": "반응 추가",
  "Admin": "관리자",
  "All results loaded": "모든 결과가 로드되었습니다",
  "Allow access to camera": "카메라에 대한 액세스 허용",
  "Allow access to microphone": "마이크로폰에 대한 액세스 허용",
  "Allow comments": "댓글 허용",
  "Allow option suggestion": "옵션 제안 허용",
  "Allow others to add comments": "다른 사람이 댓글을 추가할 수 있도록 허용",
  "Already a member": "이미 멤버입니다",
  "Also send as a direct message": "다이렉트 메시지로도 보내기",
  "Also send in channel": "채널에도 보내기",
  "Also sent in channel": "채널에도 전송됨",
  "An error has occurred during recording": "녹음 중 오류가 발생했습니다",
  "An error has occurred during the recording processing": "녹음 처리 중 오류가 발생했습니다",
  "Anonymous": "익명",
  "Anonymous poll": "익명 투표",
  "Archive": "아카이브",
  "Are you sure you want to delete this message?": "이 메시지를 삭제하시겠습니까?",
  "Are you sure you want to leave this channel?": "Are you sure you want to leave this channel?",
  "aria/Attachment": "첨부 파일",
  "aria/Attachment Actions": "첨부 파일 작업",
  "aria/Audio position {{ elapsed }} of {{ duration }}": "오디오 위치 {{ elapsed }} / {{ duration }}",
  "aria/Audio position {{ progress }} percent": "오디오 위치 {{ progress }}퍼센트",
  "aria/Block User": "사용자 차단",
  "aria/Bookmark Message": "메시지 북마크",
  "aria/Cancel recording": "녹음 취소",
  "aria/Cancel Reply": "답장 취소",
  "aria/Cancel upload": "업로드 취소",
  "aria/Channel Actions": "채널 작업",
  "aria/Channel details": "채널 세부 정보",
  "aria/Channel list": "채널 목록",
  "aria/Channel search results": "채널 검색 결과",
  "aria/Chat view tabs": "채팅 보기 탭",
  "aria/Clear search": "검색 지우기",
  "aria/Close callout dialog": "콜아웃 대화 상자 닫기",
  "aria/Close thread": "스레드 닫기",
  "aria/Collapse sidebar": "사이드바 접기",
  "aria/Command Suggestions": "명령어 제안",
  "aria/Complete recording": "녹음 완료",
  "aria/Copy Message Text": "메시지 텍스트 복사",
  "aria/Decrease value": "값 감소",
  "aria/Delete Message": "메시지 삭제",
  "aria/Dismiss notification": "알림 닫기",
  "aria/Download attachment": "첨부 파일 다운로드",
  "aria/Edit Message": "메시지 수정",
  "aria/Emoji picker": "이모지 선택기",
  "aria/Emoji Suggestions": "이모지 제안",
  "aria/Exit search": "검색 종료",
  "aria/Expand sidebar": "사이드바 확장",
  "aria/File input": "파일 입력",
  "aria/File upload": "파일 업로드",
  "aria/Flag Message": "메시지 신고",
  "aria/Image failed to load": "이미지를 불러오지 못했습니다",
  "aria/Image input": "이미지 입력",
  "aria/Increase value": "값 증가",
  "aria/Jump to latest message": "최신 메시지로 이동",
  "aria/Jump to quoted message": "인용된 메시지로 이동",
  "aria/Load More Channels": "더 많은 채널 불러오기",
  "aria/Mark Message Unread": "읽지 않음으로 표시",
  "aria/Mark messages as read": "메시지를 읽음으로 표시",
  "aria/Mention Suggestions": "멘션 제안",
  "aria/Menu": "메뉴",
  "aria/Message Actions": "메시지 작업",
  "aria/Message from {{ user }},": "{{ user }}의 메시지,",
  "aria/Message Options": "메시지 옵션",
  "aria/Message,": "메시지,",
  "aria/Mute User": "사용자 음소거",
  "aria/Next page": "다음 페이지",
  "aria/Notifications": "알림",
  "aria/Open Attachment Selector": "첨부 파일 선택기 열기",
  "aria/Open Channel Actions Menu": "채널 작업 메뉴 열기",
  "aria/Open channel details": "채널 세부 정보 열기",
  "aria/Open image shared by {{ name }}": "{{ name }}님이 공유한 이미지 열기",
  "aria/Open Menu": "메뉴 열기",
  "aria/Open Message Actions Menu": "메시지 액션 메뉴 열기",
  "aria/Open Reaction Selector": "반응 선택기 열기",
  "aria/Open Thread": "스레드 열기",
  "aria/Open video shared by {{ name }}": "{{ name }}님이 공유한 동영상 열기",
  "aria/Pause": "일시정지",
  "aria/Pause recording": "녹음 일시정지",
  "aria/Percent complete": "{{percent}}퍼센트 완료",
  "aria/Pin Message": "메시지 고정",
  "aria/Play": "재생",
  "aria/Previous page": "이전 페이지",
  "aria/Quote Message": "메시지 인용",
  "aria/Reaction list": "반응 목록",
  "aria/Remind Me Message": "알림 설정",
  "aria/Remind Me Options": "알림 옵션",
  "aria/Remove attachment": "첨부 파일 제거",
  "aria/Remove location attachment": "위치 첨부 파일 제거",
  "aria/Remove option": "옵션 제거",
  "aria/Remove Reminder": "알림 제거",
  "aria/Remove Save For Later": "나중에 보기 제거",
  "aria/Resend Message": "메시지 다시 보내기",
  "aria/Resume recording": "녹음 재개",
  "aria/Retry upload": "업로드 다시 시도",
  "aria/Review bounced message": "반송된 메시지 검토",
  "aria/Search results": "검색 결과",
  "aria/Search results header filter button for: {{ source }}": "{{ source }}에 대한 검색 결과 헤더 필터 버튼",
  "aria/Seek audio position": "오디오 위치 탐색",
  "aria/Select Channel: {{ channelName }}": "채널 선택: {{ channelName }}",
  "aria/Select Reaction: {{ reactionName }}": "반응 선택: {{ reactionName }}",
  "aria/Select User Channel: {{ name }}": "사용자 채널 선택: {{ name }}",
  "aria/Send": "보내기",
  "aria/Show preview": "미리보기 표시",
  "aria/Start recording audio": "오디오 녹음 시작",
  "aria/Stop AI Generation": "AI 생성 중지",
  "aria/Suggestions": "제안",
  "aria/Thread list": "스레드 목록",
  "aria/Unblock User": "사용자 차단 해제",
  "aria/Unmute User": "음소거 해제",
  "aria/Unpin Message": "핀 해제",
  "Ask a question": "질문하기",
  "Attach": "첨부",
  "Attach files": "파일 첨부",
  "Attachment": "첨부 파일",
  "Attachment upload blocked due to {{reason}}": "{{reason}}로 인해 첨부 파일 업로드가 차단되었습니다",
  "Attachment upload failed due to {{reason}}": "{{reason}}로 인해 첨부 파일 업로드가 실패했습니다",
  "Back": "뒤로",
  "ban-command-args": "[@사용자이름] [텍스트]",
  "ban-command-description": "사용자를 차단",
  "Block user": "사용자 차단",
  "Block User": "사용자 차단",
  "Browse channel members": "채널 멤버 보기",
  "Browse pinned messages": "고정된 메시지 보기",
  "Cancel": "취소",
  "Cannot seek in the recording": "녹음에서 찾을 수 없습니다",
  "Changes saved": "변경 사항이 저장되었습니다",
  "Channel archived": "채널이 보관됨",
  "Channel members": "채널 멤버",
  "Channel Missing": "채널 누락",
  "Channel muted": "채널이 음소거됨",
  "Channel pinned": "채널이 고정됨",
  "Channel unarchived": "채널 보관이 해제됨",
  "Channel unmuted": "채널 음소거가 해제됨",
  "Channel unpinned": "채널 고정이 해제됨",
  "Channels": "채널",
  "Chat deleted": "Chat deleted",
  "Chats": "채팅",
  "Choose between 2 to 10 options": "2~10개의 선택지 중에서 선택",
  "Close": "닫기",
  "Close dialog": "대화 상자 닫기",
  "Close emoji picker": "이모티콘 선택기 닫기",
  "Close prompt: {{ title }}": "프롬프트 닫기: {{ title }}",
  "Command not available while editing": "편집 중에는 명령을 사용할 수 없습니다",
  "Command not available while replying": "답장 중에는 명령을 사용할 수 없습니다",
  "Commands": "명령어",
  "Commands matching": "일치하는 명령",
  "Connection failure, reconnecting now...": "연결 실패, 지금 다시 연결 중...",
  "Contact info": "연락처 정보",
  "Contact name": "연락처 이름",
  "Copy Message": "메시지 복사",
  "Create": "생성",
  "Create a question, add options, and configure poll settings": "질문을 만들고 옵션을 추가한 뒤 투표 설정 구성",
  "Create poll": "투표 생성",
  "Current location": "현재 위치",
  "Delete": "삭제",
  "Delete chat": "채팅 삭제",
  "Delete for me": "나만 삭제",
  "Delete message": "메시지 삭제",
  "Delivered": "배달됨",
  "Direct message": "다이렉트 메시지",
  "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.": "지금 이 투표를 종료하시겠습니까? 종료 후에는 더 이상 투표할 수 없습니다.",
  "Download All": "모두 다운로드",
  "Download Attachment": "첨부 파일 다운로드",
  "Download attachment {{ name }}": "첨부 파일 {{ name }} 다운로드",
  "Drag your files here": "여기로 파일을 끌어다 놓으세요",
  "Drag your files here to add to your post": "게시물에 추가하려면 파일을 여기로 끌어다 놓으세요",
  "Due {{ timeLeft }}": "{{ timeLeft }}에 기한",
  "Due since {{ dueSince }}": "{{ dueSince }}부터 기한",
  "duration/Message reminder": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Remind Me": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Share Location": "{{ milliseconds | durationFormatter }}",
  "Edit": "수정",
  "Edit chat data": "채팅 데이터 수정",
  "Edit contact": "연락처 편집",
  "Edit group": "그룹 편집",
  "Edit Message": "메시지 수정",
  "Edit message request failed": "메시지 수정 요청 실패",
  "Edited": "편집됨",
  "Emoji matching": "이모티콘 매칭",
  "Empty message...": "빈 메시지...",
  "End": "종료",
  "End poll": "투표 종료",
  "End this poll?": "이 투표를 종료하시겠습니까?",
  "End vote": "투표 종료",
  "Enforce unique vote is enabled": "고유 투표가 활성화되었습니다",
  "Error": "오류",
  "Error adding flag": "플래그를 추가하는 동안 오류가 발생했습니다.",
  "Error adding members": "Error adding members",
  "Error blocking user": "사용자 차단 중 오류 발생",
  "Error connecting to chat, refresh the page to try again.": "채팅에 연결하는 동안 오류가 발생했습니다. 페이지를 새로고침하여 다시 시도하세요.",
  "Error deleting chat": "Error deleting chat",
  "Error deleting message": "메시지를 삭제하는 중에 오류가 발생했습니다.",
  "Error fetching reactions": "반응 로딩 오류.",
  "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.": "메시지를 읽지 않음으로 표시하는 중 오류가 발생했습니다. 가장 최근 100개의 채널 메시지보다 오래된 읽지 않은 메시지는 표시할 수 없습니다.",
  "Error muting a user ...": "사용자를 음소거하는 중에 오류가 발생했습니다...",
  "Error muting channel": "채널 음소거 중 오류 발생",
  "Error muting user": "사용자 음소거 중 오류 발생",
  "Error opening direct message": "다이렉트 메시지를 여는 중 오류가 발생했습니다",
  "Error pinning message": "메시지를 핀하는 중에 오류가 발생했습니다.",
  "Error removing members": "멤버를 제거하는 중 오류가 발생했습니다",
  "Error removing message pin": "메시지 핀을 제거하는 중에 오류가 발생했습니다.",
  "Error removing user": "사용자를 제거하는 중 오류가 발생했습니다",
  "Error reproducing the recording": "녹음 재생 중 오류 발생",
  "Error starting recording": "녹음 시작 중 오류가 발생했습니다",
  "Error unblocking user": "사용자 차단 해제 중 오류가 발생했습니다",
  "Error unmuting a user ...": "사용자 음소거 해제 중 오류 발생...",
  "Error unmuting channel": "채널 음소거 해제 중 오류 발생",
  "Error unmuting user": "사용자 음소거 해제 중 오류 발생",
  "Error uploading attachment": "첨부 파일 업로드 중 오류가 발생했습니다",
  "Error uploading file": "파일 업로드 오류",
  "Error uploading image": "이미지를 업로드하는 동안 오류가 발생했습니다.",
  "Error: {{ errorMessage }}": "오류: {{ errorMessage }}",
  "Exit command {{ command }}": "명령 종료 {{ command }}",
  "Failed to block user": "사용자 차단에 실패했습니다",
  "Failed to create the poll": "투표 생성 실패",
  "Failed to create the poll due to {{reason}}": "{{reason}} 때문에 투표를 생성하지 못했습니다",
  "Failed to delete the message": "메시지 삭제에 실패했습니다",
  "Failed to end the poll": "투표 종료에 실패했습니다",
  "Failed to end the poll due to {{reason}}": "{{reason}}(으)로 인해 투표 종료에 실패했습니다",
  "Failed to jump to the first unread message": "첫 번째 읽지 않은 메시지로 이동하지 못했습니다",
  "Failed to leave channel": "채널 나가기에 실패했습니다",
  "Failed to load channels": "채널을 불러오지 못했습니다",
  "Failed to load more channels": "채널을 더 불러오지 못했습니다",
  "Failed to mark channel as read": "채널을 읽음으로 표시하는 데 실패했습니다",
  "Failed to play the recording": "녹음을 재생하지 못했습니다",
  "Failed to retrieve location": "위치를 가져오지 못했습니다",
  "Failed to save changes": "변경 사항을 저장하지 못했습니다",
  "Failed to share location": "위치를 공유하지 못했습니다",
  "Failed to update channel archive status": "채널 아카이브 상태 업데이트에 실패했습니다",
  "Failed to update channel mute status": "채널 음소거 상태 업데이트에 실패했습니다",
  "Failed to update channel pinned status": "채널 고정 상태 업데이트에 실패했습니다",
  "File": "파일",
  "File is required for upload attachment": "첨부 파일 업로드에 파일이 필요합니다",
  "File is too large: {{ size }}, maximum upload size is {{ limit }}": "파일이 너무 큽니다: {{ size }}, 최대 업로드 크기는 {{ limit }}입니다",
  "File too large": "파일이 너무 큽니다",
  "fileCount_other": "파일 {{ count }}개",
  "Files": "파일",
  "Flag": "플래그",
  "Generating...": "생성 중...",
  "giphy-command-args": "[텍스트]",
  "giphy-command-description": "채널에 무작위 GIF 게시",
  "Go back": "뒤로 가기",
  "Group info": "그룹 정보",
  "Group name": "그룹 이름",
  "Hide who voted": "누가 투표했는지 숨기기",
  "Image": "이미지",
  "imageCount_other": "이미지 {{ count }}개",
  "Instant commands": "즉시 명령어",
  "language/af": "아프리칸스어",
  "language/am": "암하라어",
  "language/ar": "아랍어",
  "language/az": "아제르바이잔어",
  "language/bg": "불가리아어",
  "language/bn": "벵골어",
  "language/bs": "보스니아어",
  "language/cs": "체코어",
  "language/da": "덴마크어",
  "language/de": "독일어",
  "language/el": "그리스어",
  "language/en": "영어",
  "language/es": "스페인어",
  "language/es-MX": "스페인어(멕시코)",
  "language/et": "에스토니아어",
  "language/fa": "페르시아어",
  "language/fa-AF": "다리어",
  "language/fi": "핀란드어",
  "language/fr": "프랑스어",
  "language/fr-CA": "프랑스어(캐나다)",
  "language/ha": "하우사어",
  "language/he": "히브리어",
  "language/hi": "힌디어",
  "language/hr": "크로아티아어",
  "language/ht": "아이티 크리올어",
  "language/hu": "헝가리어",
  "language/id": "인도네시아어",
  "language/it": "이탈리아어",
  "language/ja": "일본어",
  "language/ka": "조지아어",
  "language/ko": "한국어",
  "language/lt": "리투아니아어",
  "language/lv": "라트비아어",
  "language/ms": "말레이어",
  "language/nl": "네덜란드어",
  "language/no": "노르웨이어",
  "language/pl": "폴란드어",
  "language/ps": "파슈토어",
  "language/pt": "포르투갈어",
  "language/ro": "루마니아어",
  "language/ru": "러시아어",
  "language/sk": "슬로바키아어",
  "language/sl": "슬로베니아어",
  "language/so": "소말리아어",
  "language/sq": "알바니아어",
  "language/sr": "세르비아어",
  "language/sv": "스웨덴어",
  "language/sw": "스와힐리어",
  "language/ta": "타밀어",
  "language/th": "태국어",
  "language/tl": "타갈로그어",
  "language/tr": "터키어",
  "language/uk": "우크라이나어",
  "language/ur": "우르두어",
  "language/vi": "베트남어",
  "language/zh": "중국어(간체)",
  "language/zh-TW": "중국어(번체)",
  "Last seen {{ timestamp }}": "마지막 접속 {{ timestamp }}",
  "Leave Channel": "채널 나가기",
  "Leave chat": "채널 나가기",
  "Left channel": "채널을 나갔습니다",
  "Let others add options": "다른 사람이 선택지를 추가할 수 있도록 허용",
  "Limit votes per person": "1인당 투표 수 제한",
  "Link": "링크",
  "linkCount_other": "링크 {{ count }}개",
  "live": "라이브",
  "Live for {{duration}}": "{{duration}} 동안 라이브",
  "Live location": "라이브 위치",
  "Live until {{ timestamp }}": "{{ timestamp }}까지 라이브",
  "Load more": "더 불러오기",
  "Local upload attachment missing local id": "로컬 업로드 첨부에 로컬 ID가 없습니다",
  "Location": "위치",
  "Location sharing ended": "위치 공유가 종료되었습니다",
  "Location: {{ coordinates }}": "위치: {{ coordinates }}",
  "Manage channel": "채널 관리",
  "Manage members": "멤버 관리",
  "Mark as unread": "읽지 않음으로 표시",
  "Maximum number of votes (from 2 to 10)": "최대 투표 수 (2에서 10까지)",
  "Maximum votes per person": "1인당 최대 투표 수",
  "Member detail": "멤버 상세 정보",
  "mention/Channel": "채널",
  "mention/Channel Description": "이 채널의 모두에게 알림",
  "mention/Here": "여기",
  "mention/Here Description": "이 채널의 모든 온라인 멤버에게 알림",
  "Menu": "메뉴",
  "Message deleted": "메시지가 삭제되었습니다.",
  "Message failed to send": "메시지 전송 실패",
  "Message has been successfully flagged": "메시지에 플래그가 지정되었습니다.",
  "Message marked as unread": "메시지를 읽지 않음으로 표시했습니다",
  "Message pinned": "메시지 핀했습니다",
  "Message unpinned": "메시지 고정이 해제됨",
  "Message was blocked by moderation policies": "메시지가 관리 정책에 의해 차단되었습니다.",
  "Messages have been marked unread.": "메시지가 읽지 않음으로 표시되었습니다.",
  "Missing permissions to upload the attachment": "첨부 파일을 업로드하려면 권한이 필요합니다",
  "Moderator": "운영자",
  "Multiple votes": "복수 투표",
  "Mute": "무음",
  "Mute chat": "채팅 음소거",
  "Mute user": "사용자 음소거",
  "mute-command-args": "[@사용자이름]",
  "mute-command-description": "사용자 음소거",
  "network error": "네트워크 오류",
  "New": "새로운",
  "New message from {{user}}": "{{user}}의 새 메시지",
  "New Messages!": "새 메시지!",
  "Next": "다음",
  "Next image": "다음 이미지",
  "No chats here yet…": "아직 채팅이 없습니다...",
  "No conversations yet": "아직 대화가 없습니다.",
  "No files": "파일이 없습니다",
  "No items exist": "항목이 없습니다.",
  "No member found": "멤버를 찾을 수 없습니다",
  "No messages found": "메시지를 찾을 수 없습니다",
  "No photos or videos": "사진 또는 동영상이 없습니다",
  "No pinned messages": "고정된 메시지가 없습니다",
  "No results found": "검색 결과가 없습니다",
  "No user found": "사용자를 찾을 수 없습니다",
  "Nobody will be able to vote in this poll anymore.": "이 투표에 더 이상 아무도 투표할 수 없습니다.",
  "Nothing yet...": "아직 아무것도...",
  "Notify all {{ role }} members": "{{ role }} 역할의 모든 멤버에게 알림",
  "Offline": "오프라인",
  "Ok": "확인",
  "Online": "온라인",
  "Only numbers are allowed": "숫자만 입력 가능합니다",
  "Only visible to you": "당신에게만 표시됨",
  "Open emoji picker": "이모지 선택기 열기",
  "Open gallery at image {{ index }}": "이미지 {{ index }}에서 갤러리 열기",
  "Open image in gallery": "갤러리에서 이미지 열기",
  "Open location in a map": "지도에서 위치 열기",
  "Open members actions": "Open members actions",
  "Open menu": "메뉴 열기",
  "Option already exists": "옵션이 이미 존재합니다",
  "Option is empty": "옵션이 비어 있습니다",
  "Options": "옵션",
  "Original": "원문",
  "Owner": "소유자",
  "People matching": "일치하는 사람",
  "Photo": "사진",
  "Photos & videos": "사진 및 동영상",
  "Pin": "핀",
  "Pin a message to see it here": "여기에서 보려면 메시지를 고정하세요",
  "Pinned by {{ name }}": "{{ name }}님이 핀함",
  "Pinned by You": "내가 고정함",
  "Pinned message": "고정된 메시지",
  "Pinned messages": "고정된 메시지",
  "placeholder/PollComment": "댓글",
  "placeholder/PollOptionSuggestion": "새 옵션 입력",
  "Play video": "동영상 재생",
  "Playback speed {{ rate }}x": "재생 속도 {{ rate }}x",
  "Poll": "투표",
  "Poll comments": "투표 댓글",
  "Poll ended": "투표 종료됨",
  "Poll options": "투표 옵션",
  "Poll results": "투표 결과",
  "Previous": "이전",
  "Previous image": "이전 이미지",
  "Question": "질문",
  "Question {{ optionOrderNumber}}": "질문 {{ optionOrderNumber}}",
  "Question is required": "질문이 필요합니다",
  "Quote Reply": "인용 답장",
  "Reached the vote limit. Remove an existing vote first.": "투표 한도에 도달했습니다. 기존 투표를 먼저 제거하세요.",
  "Recording format is not supported and cannot be reproduced": "녹음 형식이 지원되지 않으므로 재생할 수 없습니다",
  "Remind me": "알림",
  "Remind Me": "알림 설정",
  "Reminder set": "알림 설정됨",
  "Remove": "제거",
  "Remove {{ count }} members_other": "{{ count }}명의 멤버 제거",
  "Remove {{ member }} from this channel?": "이 채널에서 {{ member }}님을 제거하시겠습니까?",
  "Remove channel members": "채널 멤버 제거",
  "Remove reminder": "알림 제거",
  "Remove save for later": "나중에 보기 제거",
  "Remove user": "사용자 제거",
  "Removed {{ count }} members_other": "{{ count }}명의 멤버를 제거했습니다",
  "Replied to a thread": "스레드에 답글을 남겼습니다",
  "Reply": "답장",
  "Reply to {{ authorName }}": "{{ authorName }}님에게 답장",
  "Reply to a message to start a thread": "스레드를 시작하려면 메시지에 답장하세요",
  "Reply to Message": "메시지에 답장",
  "replyCount_one": "답장 1개",
  "replyCount_other": "{{ count }} 답장",
  "Resend": "다시 보내기",
  "Retry upload": "업로드 다시 시도",
  "Review all options available in this poll": "이 투표에서 사용 가능한 모든 옵션 검토",
  "Review comments submitted with poll answers": "투표 답변과 함께 제출된 댓글 검토",
  "Review poll results and open an option to see detailed votes": "투표 결과를 검토하고 옵션을 열어 상세 득표 보기",
  "Review this message and choose whether to delete it, edit it, or send it anyway": "이 메시지를 검토하고 삭제, 수정 또는 그대로 전송할지 선택",
  "Review who voted for this option": "이 옵션에 투표한 사람 검토",
  "Save": "저장",
  "Save for later": "나중에 저장",
  "Saved for later": "나중에 저장됨",
  "Search": "찾다",
  "Search GIFs": "GIF 검색",
  "search-results-header-filter-source-button-label--channels": "채널",
  "search-results-header-filter-source-button-label--messages": "메시지",
  "search-results-header-filter-source-button-label--users": "사용자",
  "Searching for {{ searchSourceType }}...": "{{ searchSourceType }} 검색 중...",
  "Searching...": "수색...",
  "searchResultsCount_one": "1개의 결과",
  "searchResultsCount_other": "{{ count }}개 결과",
  "Select a thread to continue the conversation": "대화를 계속하려면 스레드를 선택하세요",
  "Select more than one option": "하나 이상의 선택지 선택",
  "Select one": "하나 선택",
  "Select one or more": "하나 이상 선택",
  "Select up to {{count}}_one": "{{count}}개까지 선택",
  "Select up to {{count}}_other": "{{count}}개까지 선택",
  "Select your current location and optionally enable live location sharing": "현재 위치를 선택하고 필요 시 실시간 위치 공유를 활성화",
  "Send": "보내다",
  "Send a message": "메시지 보내기",
  "Send a message to start the conversation": "대화를 시작하려면 메시지를 보내세요",
  "Send Anyway": "어쨌든 보내기",
  "Send direct message": "다이렉트 메시지 보내기",
  "Send message request failed": "메시지 보내기 요청 실패",
  "Send poll": "투표 보내기",
  "Sending...": "배상중...",
  "Sent": "전송됨",
  "Share": "공유",
  "Share a file to see it here": "파일을 공유하면 여기에 표시됩니다",
  "Share a photo or video to see it here": "사진이나 동영상을 공유하면 여기에 표시됩니다",
  "Share live location for": "라이브 위치 공유",
  "Share Location": "위치 공유",
  "Shared live location": "공유된 라이브 위치",
  "Shared location": "공유된 위치",
  "Shuffle": "셔플",
  "size limit": "크기 제한",
  "Slow Mode ON": "슬로우 모드 켜짐",
  "Slow mode, wait {{ seconds }}s...": "슬로우 모드, {{ seconds }}초 기다려 주세요...",
  "Some of the files will not be accepted": "일부 파일은 허용되지 않을 수 있습니다",
  "Start typing to search": "검색하려면 입력을 시작하세요",
  "Stop sharing": "공유 중지",
  "Submit": "제출",
  "Suggest a new option to add to this poll": "이 투표에 추가할 새 옵션 제안",
  "Suggest an option": "옵션 제안",
  "Tap to remove": "제거하려면 탭하세요",
  "Tap to remove: {{ reactionName }}": "제거하려면 탭하세요: {{ reactionName }}",
  "Thinking...": "생각 중...",
  "this content could not be displayed": "이 콘텐츠를 표시할 수 없습니다",
  "This field cannot be empty or contain only spaces": "이 필드는 비워둘 수 없으며 공백만 포함할 수도 없습니다",
  "This message did not meet our content guidelines": "이 메시지는 콘텐츠 가이드라인을 충족하지 않습니다.",
  "This permanently deletes your message history with {{ user }}. This can't be undone.": "This permanently deletes your message history with {{ user }}. This can't be undone.",
  "This user will be able to message you again.": "이 사용자가 다시 메시지를 보낼 수 있습니다.",
  "This user won't be able to message you anymore. You can unblock them anytime.": "This user won't be able to message you anymore. You can unblock them anytime.",
  "Thread": "스레드",
  "Thread has not been found": "스레드를 찾을 수 없습니다",
  "Thread reply": "스레드 답장",
  "Thread Reply": "스레드 답장",
  "ThreadListUnseenThreadsBanner/loading": "로딩 중...",
  "ThreadListUnseenThreadsBanner/unreadThreads_other": "읽지 않은 스레드 {{ count }}개",
  "Threads": "스레드",
  "timestamp/ChannelDetailPinnedMessageTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Yesterday]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/ChannelMembersLastActive": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/ChannelPreviewTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[어제]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/DateSeparator": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[오늘]\", \"nextDay\": \"[내일]\", \"lastDay\": \"[어제]\", \"nextWeek\": \"dddd\", \"lastWeek\": \"[지난] dddd\", \"sameElse\": \"ddd, D MMM\" }) }}",
  "timestamp/LiveLocation": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/MessageTimestamp": "{{ timestamp | timestampFormatter(calendar: false; format: HH:mm) }}",
  "timestamp/PollVote": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/PollVoteTooltip": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/relativeDaysAgo": "{{ count }}일 전",
  "timestamp/relativeToday": "오늘",
  "timestamp/relativeWeeksAgo": "{{ count }}주 전",
  "timestamp/relativeYesterday": "어제",
  "timestamp/ReminderNotification": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[오늘] HH:mm\", \"nextDay\": \"[내일] HH:mm\", \"lastDay\": \"[어제] HH:mm\", \"nextWeek\": \"dddd HH:mm\", \"lastWeek\": \"[지난] dddd HH:mm\", \"sameElse\": \"ddd, D MMM HH:mm\" }) }}",
  "timestamp/SystemMessage": "{{ timestamp | timestampFormatter(format: dddd L) }}",
  "To start recording, allow the camera access in your browser": "브라우저에서 카메라 액세스를 허용하여 녹음을 시작합니다",
  "To start recording, allow the microphone access in your browser": "브라우저에서 마이크로폰 액세스를 허용하여 녹음을 시작합니다",
  "totalVoteCount_other": "총 {{ count }}표",
  "Translated": "번역됨",
  "Translated from {{ language }}": "{{ language }}(으)로 번역됨",
  "translationBuilderTopic/notification": "{{value, notification}}",
  "Type a number from 2 to 10": "2에서 10 사이의 숫자를 입력하세요",
  "Unarchive": "아카이브 해제",
  "unban-command-args": "[@사용자이름]",
  "unban-command-description": "사용자 차단 해제",
  "Unblock": "차단 해제",
  "Unblock user": "사용자 차단 해제",
  "Unblock User": "사용자 차단 해제",
  "unknown error": "알 수 없는 오류",
  "Unmute": "음소거 해제",
  "Unmute chat": "채팅 음소거 해제",
  "Unmute user": "사용자 음소거 해제",
  "unmute-command-args": "[@사용자이름]",
  "unmute-command-description": "사용자 음소거 해제",
  "Unpin": "핀 해제",
  "Unread messages": "읽지 않은 메시지",
  "Unsupported attachment": "지원되지 않는 첨부 파일",
  "unsupported file type": "지원되지 않는 파일 형식",
  "Update": "업데이트",
  "Update the comment attached to your poll answer": "투표 답변에 첨부된 댓글 업데이트",
  "Update your comment": "댓글 업데이트",
  "Upload blocked": "업로드가 차단되었습니다",
  "Upload error": "업로드 오류",
  "Upload failed": "업로드에 실패했습니다",
  "Upload Picture": "사진 업로드",
  "Upload type: \"{{ type }}\" is not allowed": "업로드 유형: \"{{ type }}\"은(는) 허용되지 않습니다.",
  "User blocked": "사용자가 차단됨",
  "User muted": "사용자가 음소거되었습니다",
  "User removed": "사용자가 제거되었습니다",
  "User unblocked": "사용자 차단이 해제됨",
  "User unmuted": "사용자 음소거가 해제되었습니다",
  "User uploaded content": "사용자 업로드 콘텐츠",
  "Video": "동영상",
  "videoCount_other": "동영상 {{ count }}개",
  "View": "보기",
  "View {{count}} comments_one": "{{count}}개의 댓글 보기",
  "View {{count}} comments_other": "{{count}}개의 댓글 보기",
  "View all": "전체 보기",
  "View member details for {{ member }}": "{{ member }} 멤버 상세 정보 보기",
  "View original": "원문 보기",
  "View results": "결과 보기",
  "View translation": "번역 보기",
  "Voice message": "음성 메시지",
  "Voice message {{ duration }}": "음성 메시지 {{ duration }}",
  "Voice message deleted": "음성 메시지가 삭제됨",
  "voiceMessageCount_other": "음성 메시지 {{ count }}개",
  "Vote ended": "투표 종료",
  "Votes": "투표",
  "Wait until all attachments have uploaded": "모든 첨부 파일이 업로드될 때까지 기다립니다.",
  "Waiting for network…": "네트워크 대기 중…",
  "You": "당신",
  "You've reached the maximum number of files": "최대 파일 수에 도달했습니다."
}
